import React from "react";
import { Navigate } from "react-router-dom";

const Authmiddleware = (props) => {

  // authUser yoksa login'e at (token artık HttpOnly cookie'de, JS erişemez)
  if (!localStorage.getItem("authUser")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }
  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
